module.exports = __webpack_public_path__ + "assets/img/package-default.c6d23899.jpg";